export default [
    {
        // [1]
        key: "code",
        label: app.$i18n.t("Code"),
        visible: true,
        thClass: "text-center",
        tdClass: "text-center"
    },
    {
        // [2]
        key: "load_date",
        label: "Load date",
        visible: true,
        thClass: "text-center",
        tdClass: "text-center"
    },
    {
        // [3]
        key: "delivery_date",
        label: "delivery date",
        visible: true,
        thClass: "text-center",
        tdClass: "text-center"
    },
    {
        // [4]
        key: "total_volume",
        label: "Total volume",
        visible: true,
        thClass: "text-center",
        tdClass: "text-center"
    },
    {
        // [5]
        key: "total_weight",
        label: "Total weight",
        visible: true,
        thClass: "text-center",
        tdClass: "text-center"
    },
]